export default {
      id: "collapse-usage",
      viewBox: "0 0 48 48",
      url: "/assets/" + "icons.svg#collapse",
      toString: function () {
        return this.url;
      }
    }